module.exports = __webpack_public_path__ + "img/mad.568c4514.svg";